import { useCallback, useState } from 'react';

import { useDialogs } from '../../hooks/useDialogs';
import { NamesSteps } from '@/helpers/auth';
import { BooleanString } from '@/helpers/enums';
import { Modals } from '@/helpers/modals';

interface UseLeaveRegistrationParams {
  currentRegistrationStep: NamesSteps;
}

const SHOWN_LEAVE_REG_MODAL_STEP_1 = 'SHOWN_LEAVE_REG_MODAL_STEP_1';
const SHOWN_LEAVE_REG_MODAL_STEP_2_OR_3 = 'SHOWN_LEAVE_REG_MODAL_STEP_2_OR_3';

const LEAVE_REG_MODAL_KEY_BY_STEP = {
  [NamesSteps.PRIMARY_INFORMATION]: SHOWN_LEAVE_REG_MODAL_STEP_1,
  [NamesSteps.PERSONAL_INFORMATION]: SHOWN_LEAVE_REG_MODAL_STEP_2_OR_3,
  [NamesSteps.ADDRESS_INFORMATION]: SHOWN_LEAVE_REG_MODAL_STEP_2_OR_3,
};

export const useLeaveRegistration = ({
  currentRegistrationStep,
}: UseLeaveRegistrationParams) => {
  const [isLeaveRegistrationOpen, setIsLeaveRegistrationOpen] = useState(false);
  const { modal } = useDialogs();

  const sessionStorageKey =
    LEAVE_REG_MODAL_KEY_BY_STEP[currentRegistrationStep];

  const hasShownLeaveRegistration =
    sessionStorage.getItem(sessionStorageKey) === BooleanString.TRUE ||
    modal !== Modals.Registration;

  const handleOpenLeaveRegistration = useCallback(() => {
    if (hasShownLeaveRegistration) return;

    sessionStorage.setItem(sessionStorageKey, BooleanString.TRUE);
    setIsLeaveRegistrationOpen(true);
  }, [hasShownLeaveRegistration, sessionStorageKey]);

  const handleCloseLeaveRegistration = useCallback(() => {
    setIsLeaveRegistrationOpen(false);
  }, []);

  return {
    isLeaveRegistrationOpen,
    hasShownLeaveRegistration,
    handleOpenLeaveRegistration,
    handleCloseLeaveRegistration,
  };
};
